import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/plans")({
  head: () => ({ meta: [{ title: "Plans & Pricing | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-plans")),
});
